import styled from '@emotion/styled/macro';
import vars from '../../variables';
import { defineResponsiveGridColumns } from '../../utils/utils';
import { ALIGN_IMAGE } from './aligned-image-block.types';
import { H2Atom } from '@atoms/text-atoms/text-atoms';
import { H3Atom } from '@atoms/text-atoms/text-atoms';

const baseActionButtonStyles = `
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  border-radius: 4px;
  font-weight: ${vars.fontWeightBold};
  ${vars.fontSize3};
  padding: ${vars.spacingM} ${vars.spacingL};
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  
  @media screen and (min-width: ${vars.breakPointTablet}) {
    width: auto;
  }
`;

const buttonVariants = {
  primary: `
    background-color: ${vars.coreDarkGrey};
    color: ${vars.white};
    border: 1px solid transparent;
  `,
  secondary: `
    background-color: ${vars.white};
    color: ${vars.coreDarkGrey};
    border: 1px solid ${vars.coreDarkGrey};
  `,
};

export const Wrapper = styled.div<{ alignImage: ALIGN_IMAGE }>`
  display: block;
  padding-top: 2rem;
  padding-bottom: 2rem;

  ${H2Atom},
  ${H3Atom} {
    margin-top: 2.4rem;
  }

  @media screen and (min-width: ${vars.breakPointTablet}) {
    display: grid;
    column-gap: ${vars.standardColumnPercentageGap};
    grid-template-columns: ${defineResponsiveGridColumns(12)};
    grid-template-rows: 1;
    grid-template-areas: ${({ alignImage }) =>
      alignImage === ALIGN_IMAGE.LEFT
        ? "'img img img img img . content content content content content content'"
        : "'content content content content content content . img img img img img'"};

    align-items: center;
    padding-top: 4.3rem;
    padding-bottom: 4.3rem;
  }

  .gatsby-image-pos {
    position: relative;
    width: 100%;
    border-radius: 8px;
    grid-area: img;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
`;

export const Content = styled.div`
  grid-area: content;
`;

export const Title = styled.h2`
  font-weight: ${vars.fontWeightBold};
  ${vars.fontSize8};
  letter-spacing: -0.02em;
  margin-top: 2rem;
  margin-bottom: 2rem;
  max-width: 58rem;

  @media screen and (min-width: ${vars.breakPointTablet}) {
    margin-top: 0;
  }
`;

export const CallToAction = styled.div<{ isSecondary?: boolean }>`
  ${baseActionButtonStyles}
  ${({ isSecondary }) =>
    isSecondary ? buttonVariants.secondary : buttonVariants.primary}
`;

export const RichTextWrapper = styled.div`
  margin-bottom: ${vars.spacingXl};
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${vars.spacingM};
  margin-top: ${vars.spacingS};

  @media screen and (max-width: ${vars.breakPointTablet}) {
    flex-direction: column;
  }

  @media screen and (min-width: ${vars.breakPointTablet}) {
    flex-direction: row;
  }
`;
